import { createFileRoute } from '@tanstack/react-router'

import { TempWorkerDetail } from '@/components/pages/Admin/TempWorkers/TempWorkerDetail'

export const Route = createFileRoute('/(dashboard)/admin/temp-workers/$id/')({
  component: TempWorkerDetailPage,
})

function TempWorkerDetailPage() {
  const { id } = Route.useParams()
  return <TempWorkerDetail workerId={id} />
}
